/*
 * Cookie choice for the consent-banner section. Records the visitor's answer through
 * Shopify's Customer Privacy API, which then notifies analytics.js. It only ever sets
 * the analytics purpose: that is the only non-essential technology the store uses.
 * Without JavaScript or the API the banner stays hidden and nothing is tracked.
 */
(function () {
  const banner = document.querySelector('[data-consent-banner]');
  if (!banner) return;

  const openers = document.querySelectorAll('[data-consent-open]');
  let returnFocusTo = null;

  function close() {
    banner.hidden = true;
    returnFocusTo?.focus();
    returnFocusTo = null;
  }

  function record(allowed) {
    window.Shopify.customerPrivacy.setTrackingConsent({ analytics: allowed }, (result) => {
      if (!result?.error) close();
    });
  }

  function start() {
    banner.addEventListener('click', (event) => {
      const button = event.target.closest('[data-consent-choice] button');
      if (button) record(button.closest('[data-consent-choice]').dataset.consentChoice === 'yes');
    });
    openers.forEach((opener) => {
      opener.addEventListener('click', () => {
        returnFocusTo = opener;
        banner.hidden = false;
        banner.querySelector('button').focus();
      });
    });
    if (window.Shopify.customerPrivacy.currentVisitorConsent().analytics === '') banner.hidden = false;
  }

  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
    if (!error) start();
  });
})();
